import React, { useCallback, useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Popover } from 'react-tiny-popover';
import Card, { CardBody, CardHeader, CardLabel, CardTitle } from '../../components/bootstrap/Card';
import Button from '../../components/bootstrap/Button';
import OffCanvas, {
	OffCanvasBody,
	OffCanvasHeader,
	OffCanvasTitle,
} from '../../components/bootstrap/OffCanvas';
import FormGroup from '../../components/bootstrap/forms/FormGroup';
import Input from '../../components/bootstrap/forms/Input';
import Icon from '../../components/icon/Icon';
import PaginationButtons, { PER_COUNT } from '../../components/PaginationButtonsdb';
import useSortableData from '../../hooks/useSortableData';
import useDarkMode from '../../hooks/useDarkMode';
import Select from '../../components/bootstrap/forms/Select';
import { userAuth } from '../../contexts/userContext';
import { multiinputcheck, emailRegex, nameRegex } from './vhelper/val';
import { numberRegex } from './vhelper/val';
import { nicRegex } from './vhelper/val';
import { zipRegex } from './vhelper/val';
import { charRegex } from './vhelper/val';
import { Ralert } from './vhelper/Normarodallalert';
import CountryFlagWithPhoneCodeSelector from './vhelper/flag';
import UpCountryFlagWithPhoneCodeSelector from './vhelper/upflag';
import './vhelper/flag.css';
import apiService from '../../api/apiService';
import CommonActionHeader from './Headers/commonActionHeader';
import constantString from '../../common/language/constantString';
import CustomDatePicker from '../presentation/demo-pages/helper/CustomDatePicker';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { useTranslation } from 'react-i18next';
import NoRecords from './vhelper/emptytbl';
import './customOffCanvas.css';

const CommonAdminlist = ({ isFluid }) => {
	const { t } = useTranslation();
	const { darkModeStatus, themeStatus } = useDarkMode();

	const [upcomingEventsEditOffcanvas, setUpcomingEventsEditOffcanvas] = useState(false);

	const [upcomingEventsEditOffcanvasp, setUpcomingEventsEditOffcanvasp] = useState(false);

	const [currentPage, setCurrentPage] = useState(1);
	const [perPage, setPerPage] = useState(PER_COUNT['25']);
	const [totalRows, settotalRows] = useState(25);
	const [showPassword, setShowPassword] = useState(false);
	const [promo, setPromo] = useState([]);
	const { items } = useSortableData(promo);

	const [udetail, setudetail] = useState({});

	const [isPopoverOpen, setIsPopoverOpen] = useState([]);
	const [isPoppwOpen, setIsPoppwOpen] = useState([]);

	const [upcomingEventsInfoOffcanvasss, setUpcomingEventsInfoOffcanvasss] = useState(false);
	const handleUpcomingDetailsss = () => {
		setUpcomingEventsInfoOffcanvasss(!upcomingEventsInfoOffcanvasss);
		setNewadminerror({
			Name: { error: false, msg: t('*Required') },
			Email: { error: false, msg: t('*Required') },
			Company: { error: false, msg: t('*Required') },
			Password: { error: false, msg: t('*Required') },
			Birthday: { error: false, msg: t('*Required') },
			Phonec: { error: false, msg: t('*Required') },
			tp: { error: false, msg: t('*Required') },
			gender: { error: false, msg: t('*Required') },
			nic: { error: false, msg: t('*Required') },
			state: { error: false, msg: t('*Required') },
			zip: { error: false, msg: t('*Required') },
			city: { error: false, msg: t('*Required') },
			country: { error: false, msg: t('*Required') },
			add: { error: false, msg: t('*Required') },
		});
		setNewadmin({});
	};

	const [adminpw, setAdmin] = useState('');

	const [qparam] = useSearchParams();

	const { token, setToken } = useContext(userAuth);
	const navigate = useNavigate();

	const currentDate = new Date().toISOString().split('T')[0];
	const maxSelectableDate = dayjs(currentDate).subtract(1, 'day');

	const [loadalert, setLoadalert] = useState(false);
	const [msgloadalert, setMsgLoadalert] = useState('');
	const [msgtypeloadalert, setMsgtypeLoadalert] = useState('');

	const [showPasswordnew, setShowPasswordnew] = useState(false);

	const [newadmin, setNewadmin] = useState({});

	const [newadminerror, setNewadminerror] = useState({
		Name: { error: false, msg: t('*Required') },
		Email: { error: false, msg: t('*Required') },
		Company: { error: false, msg: t('*Required') },
		Password: { error: false, msg: t('*Required') },
		Birthday: { error: false, msg: t('*Required') },
		Phonec: { error: false, msg: t('*Required') },
		tp: { error: false, msg: t('*Required') },
		gender: { error: false, msg: t('*Required') },
		nic: { error: false, msg: t('*Required') },
		state: { error: false, msg: t('*Required') },
		zip: { error: false, msg: t('*Required') },
		city: { error: false, msg: t('*Required') },
		country: { error: false, msg: t('*Required') },
		add: { error: false, msg: t('*Required') },
	});

	const [updateadminerror, setUpdateadminerror] = useState({
		ename: { error: false, msg: t('*Required') },
		compname: { error: false, msg: t('*Required') },
		dob: { error: false, msg: t('*Required') },
		phone_code: { error: false, msg: t('*Required') },
		etp: { error: false, msg: t('*Required') },
		gender: { error: false, msg: t('*Required') },
		nic: { error: false, msg: t('*Required') },
		state: { error: false, msg: t('*Required') },
		zip: { error: false, msg: t('*Required') },
		city: { error: false, msg: t('*Required') },
		country: { error: false, msg: t('*Required') },
		adline: { error: false, msg: t('*Required') },
		status: { error: false, msg: t('*Required') },
	});

	const [isLoading, setIsLoading] = useState(false);

	const [searchValue, setSearchValue] = useState('');
	const [isMobile, setIsMobile] = useState(false);
	const [isTab, setIsTab] = useState(false);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 782);
			setIsTab(window.innerWidth > 782 && window.innerWidth <= 1428);
		};

		handleResize();

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const handleCountrySelect = (selectedCountry) => {
		if (newadminerror.Phonec.error) {
			setNewadminerror((pre) => {
				const temp = {
					...pre,
					Phonec: {
						error: false,
						msg: t('*Required'),
					},
				};
				return temp;
			});
		}
		setNewadmin((pre) => {
			const temp = { ...pre };
			// temp['Phonec'] = `${selectedCountry.phoneCode}`.substring(1);
			temp.Phonec = `${selectedCountry.phoneCode}`.substring(1);
			temp.tp = '';
			return temp;
		});
	};
	const upHandleCountrySelect = (selectedCountry) => {
		setudetail((pre) => {
			const temp = { ...pre };
			// temp['phone_code'] = `${selectedCountry.phoneCode}`.substring(1);
			temp.phone_code = `${selectedCountry.phoneCode}`.substring(1);
			return temp;
		});
	};

	const [isemptyedit12] = useState({ error: false, msg: t('*Required') });

	const [isemptyeditpwr, setIsemptyeditpwr] = useState({ error: false, msg: t('*Required') });

	const [loadtable, setLoadtable] = useState(false);

	const insertBiz = async () => {
		if (isLoading) return;
		let cansendapi = multiinputcheck(
			[
				'Name',
				'Email',
				'Password',
				// 'Company',
				'Birthday',
				'Phonec',
				'tp',
				'gender',
				//'nic',
				'state',
				'zip',
				'city',
				'country',
				'add',
			],
			newadmin,
			setNewadminerror,
			{
				tp: [numberRegex, t('Only integers accepted')],
				nic: [nicRegex, t('Only integers and Character accepted')],
				zip: [zipRegex, t('Only integers and character accepted')],
				Email: [emailRegex, t('Enter an email address with a valid format.')],
				Name: [nameRegex, t('Only characters accepted')],
			},
			t('*Required'),
		);
		if (Number(newadmin.Phonec) == 94) {
			if (newadmin.tp.length < 9) {
				setNewadminerror((pre) => {
					const temp = { ...pre };
					temp['tp'] = {
						error: true,
						msg: t('Phone Number should 9 digits'),
					};
					return temp;
				});

				return;
			}
		}
		if (cansendapi) {
			setIsLoading(true);
			const formData = {};
			// let phonecodeadd;
			// tableOptionc.forEach((ele) => {
			// 	if (ele.value === newadmin.Phonec) {
			// 		phonecodeadd = ele.text;
			// 	}
			// });
			formData['admin_name'] = newadmin.Name;
			formData['admin_email'] = newadmin.Email;
			formData['password'] = newadmin.Password;
			formData['admin_company'] = newadmin.Company;
			// formData['admin_phone_code'] = phonecodeadd.substring(1);
			formData['admin_phone_code'] = newadmin.Phonec;
			formData['admin_phone'] = newadmin.tp;
			formData['admin_nic'] = newadmin.nic;
			formData['admin_gender'] = newadmin.gender;
			formData['admin_dob'] = newadmin.Birthday;
			formData['admin_address1'] = newadmin.add;
			formData['admin_city'] = newadmin.city;
			formData['admin_state'] = newadmin.state;
			formData['admin_zipcode'] = newadmin.zip;
			formData['admin_country'] = newadmin.country;
			//
			formData['action'] = 'add_administrator';

			try {
				const flechdata = await apiService(formData, token, setToken, navigate);

				if (flechdata.type === 'Success' || flechdata.type === 'success') {
					setLoadtable(!loadtable);
					setNewadmin({});
					setUpcomingEventsInfoOffcanvasss(!upcomingEventsInfoOffcanvasss);
					startmodel();
					setMsgLoadalert(flechdata.message);
					setMsgtypeLoadalert(flechdata.type);
				} else {
					startmodel();
					setMsgLoadalert(flechdata.message);
					setMsgtypeLoadalert(flechdata.type);
				}
			} catch (error) {
				console.error('Error fetching data:', error);
			} finally {
				setIsLoading(false);
			}
		}
	};

	// table
	useEffect(() => {
		if (qparam.get('search')) {
			filtersearch(qparam.get('search'));
			//
		} else {
			filterapp(currentPage, perPage);
		}
	}, [loadtable, qparam.get('search')]);

	const filterapp = async (pageid, dlimit) => {
		const item = {
			action: 'administrator_list',
			page_id: pageid,
			limit: dlimit,
		};
		const flechdata = await apiService(item, token, setToken, navigate);
		if (flechdata.type === 'Success' || flechdata.type === 'success') {
			setPromo(flechdata.data);
			settotalRows(flechdata.TotalRecords);
		}
	};

	const handlefunction = (pagenumber, limit) => {
		const pagelimit = limit ? limit : perPage;
		if (searchValue) {
			filtersearch(searchValue, pagenumber, pagelimit);
		} else {
			filterapp(pagenumber, pagelimit);
		}
	};

	// search
	const filtersearch = async (sval, pagenumber, limit) => {
		const item = {
			action: 'administrator_list',
			page_id: pagenumber ? pagenumber : currentPage,
			limit: limit ? limit : perPage,
			search_value: sval,
		};
		const flechdata = await apiService(item, token, setToken, navigate);
		if (flechdata.type === 'Success' || flechdata.type === 'success') {
			setSearchValue(sval);
			setPromo(flechdata.data);
			// setPromoc(flechdata);
			settotalRows(flechdata.TotalRecords);
		}
	};

	// edit

	const togglePasswordVisibilitynew = (value) => {
		if (value) {
			setShowPasswordnew(value);
		} else {
			setShowPasswordnew(!showPasswordnew);
		}
	};

	const handleUpcomingEdit = (id) => {
		setUpcomingEventsEditOffcanvas(!upcomingEventsEditOffcanvas);

		setUpdateadminerror({
			ename: { error: false, msg: t('*Required') },
			dob: { error: false, msg: t('*Required') },
			compname: { error: false, msg: t('*Required') },
			phone_code: { error: false, msg: t('*Required') },
			etp: { error: false, msg: t('*Required') },
			gender: { error: false, msg: t('*Required') },
			nic: { error: false, msg: t('*Required') },
			state: { error: false, msg: t('*Required') },
			zip: { error: false, msg: t('*Required') },
			city: { error: false, msg: t('*Required') },
			country: { error: false, msg: t('*Required') },
			adline: { error: false, msg: t('*Required') },
			status: { error: false, msg: t('*Required') },
		});
		const temp = promo.find((ele) => ele.id === id);
		//setudetail(temp);
		selectpcode(temp.phone_code);
		getSingleAdminData(id);
	};

	const getSingleAdminData = useCallback(async (id) => {
		const formData = {};
		formData['admin_id'] = id;
		formData['action'] = 'get_admin_data';

		const flechdata = await apiService(formData, token, setToken, navigate);
		if (flechdata.type === 'Success' || flechdata.type === 'success') {
			setudetail(flechdata.data[0]);
		}
	});

	const selectpcode = (pcode) => {
		const phone_code = uptableOptionc.find((d) => d.phoneCode === `+${pcode}`);
		if (phone_code?.phoneCode) return phone_code;
		else return '';
	};

	const handleUpcomingEditp = (id) => {
		setUpcomingEventsEditOffcanvasp(!upcomingEventsEditOffcanvasp);
		setIsemptyeditpwr({ error: false, msg: t('*Required') });
		setAdmin('');
		const temp = promo.find((ele) => ele.id === id);
		setudetail(temp);
	};

	// update
	const updatebiz = async () => {
		if (isLoading) return;
		const cansendapi = multiinputcheck(
			[
				'ename',
				// 'Upassword',
				//'compname',
				'dob',
				'phone_code',
				'etp',
				'gender',
				// 'nic',
				'state',
				'zip',
				'city',
				'country',
				'adline',
				'status',
			],
			udetail,
			setUpdateadminerror,
			{
				// phone_code: [phonecodeRegex, 'Only integers and + Symbol accepted'],
				etp: [numberRegex, t('Only integers accepted')],
				nic: [nicRegex, t('Only integers and Characters accepted')],
				zip: [zipRegex, t('Only integers and character accepted')],
				ename: [nameRegex, t('Only characters accepted')],
			},
			t('*Required'),
		);
		if (Number(udetail.phone_code) == 94) {
			if (udetail.etp.length < 9) {
				setUpdateadminerror((pre) => {
					const temp = { ...pre };
					temp['etp'] = {
						error: true,
						msg: t('Phone Number should 9 digits'),
					};
					return temp;
				});

				return;
			}
		}
		if (cansendapi) {
			setIsLoading(true);
			const formData = {};
			// let phonecodeadd;
			// uptableOptionc.forEach((ele) => {
			// 	if (ele.value === udetail.phone_code) {
			// 		phonecodeadd = ele.text;
			// 	}
			// });
			formData['admin_name'] = udetail.ename;
			formData['admin_company'] = udetail.compname;
			// formData['admin_phone_code'] = phonecodeadd.substring(1);
			formData['admin_phone_code'] = udetail.phone_code;
			formData['admin_phone'] = udetail.etp;

			formData['admin_nic'] = udetail.nic;
			formData['admin_gender'] = udetail.gender;
			formData['admin_dob'] = udetail.dob;
			formData['admin_address1'] = udetail.adline;

			formData['admin_city'] = udetail.city;
			formData['admin_state'] = udetail.state;
			formData['admin_zipcode'] = udetail.zip;
			formData['admin_country'] = udetail.country;

			formData['admin_status'] = udetail.status;

			formData['action'] = 'update_administrator';
			formData['admin_id'] = udetail.id;

			try {
				const flechdata = await apiService(formData, token, setToken, navigate);

				if (flechdata.type === 'Success' || flechdata.type === 'success') {
					setLoadtable(!loadtable);
					setUpcomingEventsEditOffcanvas(!upcomingEventsEditOffcanvas);
					startmodel();
					setMsgLoadalert(flechdata.message);
					setMsgtypeLoadalert(flechdata.type);
				} else {
					startmodel();
					setMsgLoadalert(flechdata.message);
					setMsgtypeLoadalert(flechdata.type);
				}
			} catch (error) {
				console.error('Error fetching data:', error);
			} finally {
				setIsLoading(false);
			}
		}
	};

	const updateemppw = async () => {
		if (isLoading) return;
		let cansendapi = true;
		if (!adminpw) {
			setIsemptyeditpwr({ error: true, msg: t('*Required') });
			cansendapi = false;
		} else {
			setIsemptyeditpwr({ error: false });
		}
		if (cansendapi) {
			setIsLoading(true);
			const formData = {};
			formData['password'] = adminpw;

			formData['action'] = 'update_admin_password';
			formData['admin_id'] = udetail.id;

			try {
				const flechdata = await apiService(formData, token, setToken, navigate);

				if (flechdata.type === 'Success' || flechdata.type === 'success') {
					setUpcomingEventsEditOffcanvasp(!upcomingEventsEditOffcanvasp);
					setLoadtable(!loadtable);
					startmodel();
					setMsgLoadalert(flechdata.message);
					setMsgtypeLoadalert(flechdata.type);
				} else {
					startmodel();
					setMsgLoadalert(flechdata.message);
					setMsgtypeLoadalert(flechdata.type);
				}
			} catch (error) {
				console.error('Error fetching data:', error);
			} finally {
				setIsLoading(false);
			}
		}
	};

	const [tableOption, setTableOption] = useState([]);
	const [uptableOption, setUpTableOption] = useState([]);

	const [tableOptionc, setTableOptionc] = useState([]);
	const [uptableOptionc, setUpTableOptionc] = useState([]);

	useEffect(() => {
		const fetchata = async () => {
			const item = { action: 'get_settings' };
			const flechdata = await apiService(item, token, setToken, navigate);

			if (Array.isArray(Object.entries(flechdata.country_list))) {
				const temp = Object.entries(flechdata.country_list).map((ele) => ({
					code: ele[0],
					name: ele[1],
					phoneCode: `+${flechdata.country_phone_code[ele[0]]}`,
				}));
				//
				setTableOptionc(temp);
				setUpTableOptionc(temp);

				if (Array.isArray(temp)) {
					if (temp[0].code) {
						setudetail((pre) => {
							const tempp = {
								...pre,
								phone_code: temp[0].code,
							};
							//
							return tempp;
						});
					}
				}
				//
			}
			//

			// country list

			const countrylist = Object.entries(flechdata.country_list);
			const temp = countrylist.map((ele) => ({
				value: ele[0],
				text: ele[1],
			}));
			setTableOption(temp);
			setUpTableOption(temp);
			if (Array.isArray(temp)) {
				if (temp[0].value) {
					setNewadmin((pre) => {
						const tempp = {
							...pre,
							country: null,
						};
						return tempp;
					});
				}
			}
			if (Array.isArray(temp)) {
				if (temp[0].value) {
					setudetail((pre) => {
						const tempp = {
							...pre,
							country: null,
						};
						return tempp;
					});
				}
			}
		};
		fetchata();
	}, []);

	const togglePasswordVisibility = (value) => {
		if (value) {
			setShowPassword(value);
		} else {
			setShowPassword(!showPassword);
		}
	};

	const closemodel = () => {
		setLoadalert(false);
	};
	const startmodel = () => {
		setLoadalert(true);
	};
	return (
		<>
			<Ralert
				msgloadalert={msgloadalert}
				msgtypeloadalert={msgtypeloadalert}
				loadalert={loadalert}
				closemodel={closemodel}
			/>
			<div style={{ marginTop: '20px', marginLeft: '20px', marginRight: '20px' }}>
				<div className='row mb-4'>
					<div className='col-auto'>
						<CardLabel icon='Alarm' iconColor='info'>
							<CardTitle tag={isMobile ? 'h5' : 'h3'}>
								{t('Administrators')}
							</CardTitle>
						</CardLabel>
					</div>

					<div className='col-auto me-auto'>
						<div class='d-flex' style={{ height: '100%' }}>
							<div class='vr visually-hidden'></div>
						</div>
					</div>

					<div className='col-auto me-3 align-self-end'>
						<Button
							icon='PersonAdd'
							color='primary'
							isLight
							onClick={() => handleUpcomingDetailsss(true)}>
							{t('New Admin')}
						</Button>
					</div>
				</div>
				<Card stretch={isFluid} style={{ width: '100%' }}>
					<CardHeader borderSize={1}>
						{/*<CardLabel icon='Alarm' iconColor='info'>
						<CardTitle>Admin List</CardTitle>
					</CardLabel>
					<CardActions>
						<div className='row'>
							<div className='col-5'>
								<Button
									icon='PersonAdd'
									color='primary'
									isLight
									onClick={() => handleUpcomingDetailsss(true)}>
									New Admin
								</Button>
							</div>
							<div className='col-7'>
								<FormGroup>
								<Input type='text' placeholder='Search...' onKeyUp={(e) => {
										 if(e.key==='Enter'){
											filtersearch(e.target.value)
										 }
										}} />
								</FormGroup>
							</div>
						</div>
					</CardActions>*/}
						{/*<CardActions className='w-100'>
							<div className='row align-items-center d-flex'>
								<div className='col-auto'>
									<span className='text-muted'>Show</span>
								</div>
								<div className='col-auto px-0'>
									<Select
										size='sm'
										ariaLabel='Per'
										onChange={(e) => {
											setPerPage(parseInt(e.target.value, 10));
											setCurrentPage(1);
											handlefunction(1, parseInt(e.target.value, 10));
										}}
										value={perPage.toString()}>
										{Object.keys(PER_COUNT).map((i) => (
											<SelectOption key={i} value={i}>
												{i}
											</SelectOption>
										))}
									</Select>
								</div>
								<div className='col-auto'>
									<span className='text-muted'>entries</span>
								</div>
								<div className='col-auto ms-auto'>
									<div className='row align-items-center'>
										<div className='col-auto ms-auto '>
											<span className='text-muted'>Search:</span>
										</div>
										<div className='col'>
											<FormGroup>
												<Input
													type='text'
													placeholder='Search here...'
													onKeyUp={(e) => {
														if (e.key === 'Enter') {
															filtersearch(e.target.value);
														}
													}}
												/>
											</FormGroup>
										</div>
									</div>
								</div>
							</div>
						</CardActions>*/}
						<CommonActionHeader
							preCount={PER_COUNT}
							perPage={perPage.toString()}
							onKeyUp={(value) => {
								// const param=new URLSearchParams()
								// param.set("search",value)
								// navigate({pathname:"/admins",search:param.toString()})
								filtersearch(value);
							}}
							onChange={(e) => {
								setPerPage(parseInt(e.target.value, 10));
								setCurrentPage(1);
								handlefunction(1, parseInt(e.target.value, 10));
							}}
						/>
					</CardHeader>
					<CardBody
						className='table-responsive'
						isScrollable={isFluid}
						style={{ position: 'sticky', paddingTop: '0' }}>
						<table className='table table-modern'>
							<thead>
								<tr
									style={{
										position: 'sticky',
										top: '0',
										backgroundColor:
											themeStatus === 'dark' ? '#141414' : '#e5e5e5',
										zIndex: 10,
									}}>
									<th>{t('ID')}</th>
									<th>{t('Name')}</th>
									<th>{t('Email')}</th>
									<th>{t('Birth Date')}</th>
									<th>{t('Mobile')}</th>
									<th>{t('NIC')}</th>
									<th>{t('Gender')}</th>
									<th>{t('Country')}</th>
									<th>{t('Status')}</th>
									<th>{t('Action')}</th>
								</tr>
							</thead>
							<tbody>
								{promo?.length > 0 ? (
									promo?.map((item, index) => (
										<tr key={item.id}>
											<td>{item.user_code}</td>
											<td>{item.ename}</td>
											<td>{item.eemail}</td>
											<td>{item.dob}</td>
											<td>{item.etp}</td>
											<td>{item.nic}</td>
											<td>{item.gender === 'm' ? t('Male') : t('Female')}</td>
											<td>{item.country}</td>
											{/* <td>{item.estatus == '1' ? 'Active' : 'Inactive'}</td> */}
											<td>
												{item.status === '1' ? (
													<Icon icon='Done Outline' color='success' />
												) : (
													<Icon icon='DoDisturb' color='danger' />
												)}
											</td>
											<td style={{ display: 'flex', paddingBottom: '20px' }}>
												<div style={{ marginRight: '10px' }}>
													<Popover
														isOpen={isPopoverOpen[index]}
														positions={['left']}
														content={
															<div>
																<span
																	style={{
																		backgroundColor:
																			'rgba(0, 0, 0, 0.85)',
																		borderRadius: '5px',
																		bottom: '1px',
																		boxShadow:
																			'0 0 5px rgba(0, 0, 0, 0.4)',
																		color: '#fff',
																		fontSize: '12px',
																		fontFamily:
																			'Helvetica, sans-serif',
																		left: '-45px',
																		padding: '7px 10px',
																		position: 'absolute',
																		width: '48px',
																		zIndex: 4,
																	}}>
																	{t('Edit')}
																</span>
															</div>
														}>
														<div
															onMouseEnter={() =>
																setIsPopoverOpen((pre) => {
																	const temp = [...pre];
																	temp[index] = true;
																	return temp;
																})
															}
															onMouseLeave={() =>
																setIsPopoverOpen((pre) => {
																	const temp = [...pre];
																	temp[index] = false;
																	return temp;
																})
															}>
															<Button
																isOutline={!darkModeStatus}
																color='dark'
																isLight={darkModeStatus}
																className={classNames(
																	'text-nowrap',
																	{
																		'border-light':
																			!darkModeStatus,
																	},
																)}
																icon='Edit'
																style={{
																	background: 'transparent',
																	width: 'auto',
																	padding: '5px',
																}}
																onClick={() =>
																	handleUpcomingEdit(item.id)
																}
															/>
														</div>
													</Popover>
												</div>
												<div style={{ marginRight: '10px' }}>
													<Popover
														isOpen={isPoppwOpen[index]}
														positions={['left']}
														content={
															<div>
																<span
																	style={{
																		backgroundColor:
																			'rgba(0, 0, 0, 0.85)',
																		borderRadius: '5px',
																		bottom: '1px',
																		boxShadow:
																			'0 0 5px rgba(0, 0, 0, 0.4)',
																		color: '#fff',
																		fontSize: '12px',
																		fontFamily:
																			'Helvetica, sans-serif',
																		left: '-35px',
																		padding: '7px 10px',
																		position: 'absolute',
																		width: '120px',
																		zIndex: 4,
																	}}>
																	{t('Change Password')}
																</span>
															</div>
														}>
														<div
															onMouseEnter={() =>
																setIsPoppwOpen((pre) => {
																	const temp = [...pre];
																	temp[index] = true;
																	return temp;
																})
															}
															onMouseLeave={() =>
																setIsPoppwOpen((pre) => {
																	const temp = [...pre];
																	temp[index] = false;
																	return temp;
																})
															}>
															<Button
																isOutline={!darkModeStatus}
																color='dark'
																isLight={darkModeStatus}
																className={classNames(
																	'text-nowrap',
																	{
																		'border-light':
																			!darkModeStatus,
																	},
																)}
																icon='key'
																style={{
																	background: 'transparent',
																	width: 'auto',
																	padding: '5px',
																}}
																onClick={() =>
																	handleUpcomingEditp(item.id)
																}
															/>
														</div>
													</Popover>
												</div>
											</td>
										</tr>
									))
								) : (
									<NoRecords />
								)}
							</tbody>
						</table>
					</CardBody>
					<PaginationButtons
						data={items}
						handlefunction={handlefunction}
						totalrows={totalRows}
						label={t('items')}
						setCurrentPage={setCurrentPage}
						currentPage={currentPage}
						perPage={perPage}
						setPerPage={setPerPage}
					/>
				</Card>
			</div>

			<OffCanvas
				setOpen={setUpcomingEventsEditOffcanvas}
				isOpen={upcomingEventsEditOffcanvas}
				titleId='upcomingEdit'
				className='custom-offcanvas-width'
				//isBodyScroll
				placement='end'>
				<OffCanvasHeader
					setOpen={setUpcomingEventsEditOffcanvas}
					onHandle={() => {
						setudetail({});
					}}>
					<OffCanvasTitle id='upcomingEdit'>{t('Edit Admin')}</OffCanvasTitle>
				</OffCanvasHeader>
				<OffCanvasBody>
					<div className='row g-4'>
						<div className='col-6'>
							<FormGroup id='uname' label={t('Full Name')}>
								<Input
									// value={updateemployee.Uname}
									style={{
										border: updateadminerror.ename.error
											? '2px solid red'
											: '2px solid transparent',
									}}
									onChange={(e) => {
										if (updateadminerror.ename.error) {
											setUpdateadminerror((pre) => {
												const temp = {
													...pre,
													ename: {
														error: false,
														msg: t('*Required'),
													},
												};
												return temp;
											});
										}
										setudetail((pre) => {
											const temp = {
												...pre,
												ename: e.target.value,
											};
											return temp;
										});
									}}
									value={udetail.ename}
								/>
							</FormGroup>
							{updateadminerror.ename.error && (
								<p
									style={{
										color: 'red',
										fontSize: '12px',
									}}>
									{' '}
									{updateadminerror.ename.msg
										? updateadminerror.ename.msg
										: t('*Required')}
								</p>
							)}
						</div>

						<div className='col-6'>
							<FormGroup id='company' label={t('Company')}>
								<Input
									style={{
										border: updateadminerror.compname.error
											? '2px solid red'
											: '2px solid transparent',
									}}
									onChange={(e) => {
										if (updateadminerror.compname.error) {
											setUpdateadminerror((pre) => {
												const temp = {
													...pre,
													compname: {
														error: false,
														msg: t('*Required'),
													},
												};
												return temp;
											});
										}
										setudetail((pre) => {
											const temp = {
												...pre,
												compname: e.target.value,
											};
											return temp;
										});
									}}
									value={udetail.compname}
								/>
							</FormGroup>
							{updateadminerror.compname.error && (
								<p
									style={{
										color: 'red',
										fontSize: '12px',
									}}>
									{' '}
									{updateadminerror.compname.msg
										? updateadminerror.compname.msg
										: t('*Required')}
								</p>
							)}
						</div>
						<div className='col-4'>
							<FormGroup id='country' label={t('Country')}>
								<Select
									list={tableOption}
									style={{
										border: updateadminerror.country.error
											? '2px solid red'
											: '2px solid transparent',
									}}
									onChange={(e) => {
										if (updateadminerror.country.error) {
											setUpdateadminerror((pre) => {
												const temp = {
													...pre,
													country: {
														error: false,
														msg: t('*Required'),
													},
												};
												return temp;
											});
										}
										setudetail((pre) => {
											const temp = {
												...pre,
												country: e.target.value,
												phone_code: e.target.value,
											};
											return temp;
										});
									}}
									value={udetail.country}
								/>
							</FormGroup>
							{updateadminerror.country.error && (
								<p
									style={{
										color: 'red',
										fontSize: '12px',
									}}>
									{' '}
									{updateadminerror.country.msg
										? updateadminerror.country.msg
										: t('*Required')}
								</p>
							)}
						</div>
						<div className='col-4' style={{ position: 'relative' }}>
							<FormGroup label={t('Phone Code')}>
								<UpCountryFlagWithPhoneCodeSelector
									onSelect={upHandleCountrySelect}
									uptableOptionc={uptableOptionc}
									value={selectpcode(udetail.phone_code)}
								/>
							</FormGroup>

							{updateadminerror.phone_code.error && (
								<p
									style={{
										color: 'red',
										fontSize: '12px',
									}}>
									{' '}
									{updateadminerror.phone_code.msg
										? updateadminerror.phone_code.msg
										: t('*Required')}
								</p>
							)}
						</div>
						<div className='col-4'>
							<FormGroup id='tp' label={`${t('Mobile No')}:`}>
								<Input
									// value={updateemployee.Utp}
									style={{
										border: updateadminerror.etp.error
											? '2px solid red'
											: '2px solid transparent',
									}}
									onChange={(e) => {
										if (updateadminerror.etp.error) {
											setUpdateadminerror((pre) => {
												const temp = {
													...pre,
													etp: {
														error: false,
														msg: t('*Required'),
													},
												};
												return temp;
											});
										}
										if (Number(udetail.phone_code) == 94) {
											if (e.target.value.length < 10) {
												setudetail((pre) => {
													const temp = {
														...pre,
														etp: e.target.value,
													};
													return temp;
												});
											}
										} else {
											setudetail((pre) => {
												const temp = {
													...pre,
													etp: e.target.value,
												};
												return temp;
											});
										}
									}}
									value={udetail.etp}
								/>
							</FormGroup>
							{updateadminerror.etp.error && (
								<p
									style={{
										color: 'red',
										fontSize: '12px',
									}}>
									{' '}
									{updateadminerror.etp.msg
										? updateadminerror.etp.msg
										: t('*Required')}
								</p>
							)}
						</div>
						<div className='col-6'>
							<FormGroup id='gender' label={t('Gender')}>
								<Select
									placeholder={`${t('Choose')}...`}
									list={[
										{ value: 'f', text: 'Female' },
										{ value: 'm', text: 'Male' },
									]}
									// style={{
									// 	border: isemptyedit4
									// 		? '2px solid red'
									// 		: '2px solid transparent',
									// }}
									value={udetail.gender}
									onChange={(e) => {
										setudetail((pre) => {
											const temp = {
												...pre,
												gender: e.target.value,
											};
											return temp;
										});
									}}
								/>
							</FormGroup>
							{/* {isemptyedit4 && (
								<p
									style={{
										color: 'red',
										fontSize: '12px',
									}}>
									*Required
								</p>
							)} */}
						</div>
						<div className='col-6'>
							<FormGroup id='dob' label={t('Birth Date')}>
								<CustomDatePicker
									styleValue={updateadminerror.dob.error}
									maxDate={maxSelectableDate}
									value={udetail.dob ? dayjs(udetail.dob, 'YYYY-MM-DD') : null}
									onChange={(date, dateString) => {
										const formattedDate = date
											? dayjs(date).format('YYYY-MM-DD')
											: '';

										if (updateadminerror.dob.error) {
											setUpdateadminerror((pre) => {
												const temp = {
													...pre,
													dob: {
														error: false,
														msg: t('*Required'),
													},
												};
												return temp;
											});
										}
										setudetail((pre) => {
											const temp = {
												...pre,
												dob: formattedDate,
											};
											return temp;
										});
									}}
								/>
							</FormGroup>
							{updateadminerror.dob.error && (
								<p
									style={{
										color: 'red',
										fontSize: '12px',
									}}>
									{' '}
									{updateadminerror.dob.msg
										? updateadminerror.dob.msg
										: t('*Required')}
								</p>
							)}
						</div>

						<div className='col-4'>
							<FormGroup id='nic' label={t('NIC')}>
								<Input
									value={udetail.nic}
									// value={updateemployee.Unic}
									style={{
										border: updateadminerror.nic.error
											? '2px solid red'
											: '2px solid transparent',
									}}
									onChange={(e) => {
										if (updateadminerror.nic.error) {
											setUpdateadminerror((pre) => {
												const temp = {
													...pre,
													nic: {
														error: false,
														msg: t('*Required'),
													},
												};
												return temp;
											});
										}
										setudetail((pre) => {
											const temp = {
												...pre,
												nic: e.target.value,
											};
											return temp;
										});
									}}
								/>
							</FormGroup>
							{updateadminerror.nic.error && (
								<p
									style={{
										color: 'red',
										fontSize: '12px',
									}}>
									{' '}
									{updateadminerror.nic.msg
										? updateadminerror.nic.msg
										: t('*Required')}
								</p>
							)}
						</div>

						<div className='col-8'>
							<FormGroup id='ad' label={t('Address')}>
								<Input
									// value={updateemployee.Uadd}
									style={{
										border: updateadminerror.adline.error
											? '2px solid red'
											: '2px solid transparent',
									}}
									onChange={(e) => {
										if (updateadminerror.adline.error) {
											setUpdateadminerror((pre) => {
												const temp = {
													...pre,
													adline: {
														error: false,
														msg: t('*Required'),
													},
												};
												return temp;
											});
										}
										setudetail((pre) => {
											const temp = {
												...pre,
												adline: e.target.value,
											};
											return temp;
										});
									}}
									value={udetail.adline}
								/>
							</FormGroup>
							{updateadminerror.adline.error && (
								<p
									style={{
										color: 'red',
										fontSize: '12px',
									}}>
									{' '}
									{updateadminerror.adline.msg
										? updateadminerror.adline.msg
										: t('*Required')}
								</p>
							)}
						</div>
						<div className='col-6'>
							<FormGroup id='city' label={t('City')}>
								<Input
									// value={updateemployee.Ucity}
									style={{
										border: updateadminerror.city.error
											? '2px solid red'
											: '2px solid transparent',
									}}
									onChange={(e) => {
										if (updateadminerror.city.error) {
											setUpdateadminerror((pre) => {
												const temp = {
													...pre,
													city: {
														error: false,
														msg: t('*Required'),
													},
												};
												return temp;
											});
										}
										setudetail((pre) => {
											const temp = {
												...pre,
												city: e.target.value,
											};
											return temp;
										});
									}}
									value={udetail.city}
								/>
							</FormGroup>
							{updateadminerror.city.error && (
								<p
									style={{
										color: 'red',
										fontSize: '12px',
									}}>
									{' '}
									{updateadminerror.city.msg
										? updateadminerror.city.msg
										: t('*Required')}
								</p>
							)}
						</div>
						<div className='col-6'>
							<FormGroup id='state' label={t('State')}>
								<Input
									style={{
										border: updateadminerror.state.error
											? '2px solid red'
											: '2px solid transparent',
									}}
									onChange={(e) => {
										if (updateadminerror.state.error) {
											setUpdateadminerror((pre) => {
												const temp = {
													...pre,
													state: {
														error: false,
														msg: t('*Required'),
													},
												};
												return temp;
											});
										}
										setudetail((pre) => {
											const temp = {
												...pre,
												state: e.target.value,
											};
											return temp;
										});
									}}
									value={udetail.state}
								/>
							</FormGroup>
							{updateadminerror.state.error && (
								<p
									style={{
										color: 'red',
										fontSize: '12px',
									}}>
									{' '}
									{updateadminerror.state.msg
										? updateadminerror.state.msg
										: t('*Required')}
								</p>
							)}
						</div>
						<div className='col-6'>
							<FormGroup id='zip' label={t('Zip Code')}>
								<Input
									style={{
										border: updateadminerror.zip.error
											? '2px solid red'
											: '2px solid transparent',
									}}
									onChange={(e) => {
										if (updateadminerror.zip.error) {
											setUpdateadminerror((pre) => {
												const temp = {
													...pre,
													zip: {
														error: false,
														msg: t('*Required'),
													},
												};
												return temp;
											});
										}
										setudetail((pre) => {
											const temp = {
												...pre,
												zip: e.target.value,
											};
											return temp;
										});
									}}
									value={udetail.zip}
								/>
							</FormGroup>
							{updateadminerror.zip.error && (
								<p
									style={{
										color: 'red',
										fontSize: '12px',
									}}>
									{' '}
									{updateadminerror.zip.msg
										? updateadminerror.zip.msg
										: t('*Required')}
								</p>
							)}
						</div>
						<div className='col-6'>
							<FormGroup id='ustatus' label={t('Status')}>
								<Select
									placeholder={`${t('Choose')}...`}
									list={[
										{ value: '1', text: t('Active') },
										{ value: '0', text: t('Inactive') },
									]}
									onChange={(e) => {
										e.preventDefault();
										setudetail((pre) => {
											const temp = {
												...pre,
												status: e.target.value,
											};
											return temp;
										});
									}}
									value={udetail.status}
								/>
							</FormGroup>
						</div>
					</div>
					{isTab && (
						<div className='col-12 pt-5'>
							<Button
								color='info'
								className='w-100'
								onClick={updatebiz}
								disabled={isLoading}>
								{t('Update')}
							</Button>
						</div>
					)}
				</OffCanvasBody>
				{!isTab && (
					<div className='col-12 p-3'>
						<Button
							color='info'
							className='w-100'
							onClick={updatebiz}
							disabled={isLoading}>
							{t('Update')}
						</Button>
					</div>
				)}
			</OffCanvas>
			<OffCanvas
				setOpen={setUpcomingEventsEditOffcanvasp}
				isOpen={upcomingEventsEditOffcanvasp}
				titleId='upcomingEdit'
				//isBodyScroll
				placement='end'>
				<OffCanvasHeader setOpen={setUpcomingEventsEditOffcanvasp}>
					<OffCanvasTitle id='upcomingEdit'>{t('Edit Admin Password')}</OffCanvasTitle>
				</OffCanvasHeader>
				<OffCanvasBody>
					<div
						className='row g-4'
						style={{
							display: 'flex',
							alignItems: 'center',
							marginTop: '3px',
							paddingTop: '3px',
						}}>
						<div className='col-12'>
							<FormGroup label={t('New Password')}>
								<Input
									style={{
										border: isemptyeditpwr.error
											? '2px solid red'
											: '2px solid transparent',
									}}
									onChange={(e) => {
										if (isemptyedit12) {
											setIsemptyeditpwr({ error: false });
										}
										setAdmin(e.target.value);
									}}
									type={showPassword ? 'text' : 'password'}
								/>
								<button
									type='button'
									onClick={() => togglePasswordVisibility()}
									style={{
										position: 'absolute',
										right: '20px', // Adjust the right position as needed
										top: '135px',
										transform: 'translateY(-50%)',
										border: 'none',
										background: 'none',
										cursor: 'pointer',
									}}>
									{showPassword ? (
										<Icon
											style={{
												color: themeStatus === 'dark' ? '#c9c3c3' : 'black',
											}}
											icon='Visibility'
											size='2x'
										/>
									) : (
										<Icon
											style={{
												color: themeStatus === 'dark' ? '#c9c3c3' : 'black',
											}}
											icon='VisibilityOff'
											size='2x'
										/>
									)}{' '}
								</button>
							</FormGroup>
							{isemptyeditpwr.error && (
								<p
									style={{
										color: 'red',
										fontSize: '12px',
									}}>
									{' '}
									{isemptyeditpwr.msg ? isemptyeditpwr.msg : t('*Required')}
								</p>
							)}
						</div>
					</div>

					<div
						className='col-12 pt-3'
						style={{
							display: 'flex',
							alignItems: 'center',
							marginTop: '20px',
							marginBottom: '10px',
							// borderBottom: '2px solid black',
							paddingTop: '30px',
						}}>
						<Button
							color='info'
							className='w-100'
							onClick={updateemppw}
							disabled={isLoading}>
							{t('Update')}
						</Button>
					</div>
				</OffCanvasBody>
			</OffCanvas>

			<OffCanvas
				setOpen={setUpcomingEventsInfoOffcanvasss}
				onHandle={() => togglePasswordVisibilitynew(false)}
				isOpen={upcomingEventsInfoOffcanvasss}
				titleId='upcomingDetails'
				className='custom-offcanvas-width'
				placement='end'>
				<OffCanvasHeader setOpen={setUpcomingEventsInfoOffcanvasss}>
					{/* dgdgd */}
				</OffCanvasHeader>
				<OffCanvasBody>
					<div className='row'>
						{/* <div className='col-md-6' Style='width: 600px'>
							<Card className='rounded-1 mb-0'>
								<CardHeader>
									<CardLabel icon='ReceiptLong'>
										<CardTitle>New Category</CardTitle>
									</CardLabel>
								</CardHeader>
								<CardBody>
									<div className='row g-3'>
										<FormGroup
											id='streetAddress'
											label='Category Name'
											className='col-12'>
											<Input
												id='catname'
												onChange={(e) => setCatname(e.target.value)}
												value={formik.values.streetAddress}
											/>
										</FormGroup>

										<Button color='info' onClick={insertCategory}>
											Save
										</Button>
									</div>
								</CardBody>
							</Card>
						</div> */}
						<br />
						<div className='col-md-6' Style='width: 800px'>
							<Card className='rounded-1 mb-0'>
								<CardHeader>
									<CardLabel icon='PersonAdd'>
										<CardTitle>{t('Add New Admin')}</CardTitle>
									</CardLabel>
								</CardHeader>
								<CardBody>
									<div className='row g-3'>
										<div className='col-6'>
											<FormGroup id='name' label={t('Full Name')}>
												<Input
													type='text'
													value={newadmin.Name}
													style={{
														border: newadminerror.Name.error
															? '2px solid red'
															: '2px solid transparent',
													}}
													onChange={(e) => {
														if (newadminerror.Name.error) {
															setNewadminerror((pre) => {
																const temp = {
																	...pre,
																	Name: {
																		error: false,
																		msg: t('*Required'),
																	},
																};
																return temp;
															});
														}
														setNewadmin((pre) => {
															const temp = {
																...pre,
																Name: e.target.value,
															};
															return temp;
														});
													}}
												/>
											</FormGroup>
											{newadminerror.Name.error && (
												<p
													style={{
														color: 'red',
														fontSize: '12px',
													}}>
													{' '}
													{newadminerror.Name.msg
														? newadminerror.Name.msg
														: t('*Required')}
												</p>
											)}
										</div>
										<div className='col-6'>
											<FormGroup id='cname' label={t('Company')}>
												<Input
													type='text'
													value={newadmin.Company}
													style={{
														border: newadminerror.Company.error
															? '2px solid red'
															: '2px solid transparent',
													}}
													onChange={(e) => {
														if (newadminerror.Company.error) {
															setNewadminerror((pre) => {
																const temp = {
																	...pre,
																	Company: {
																		error: false,
																		msg: t('*Required'),
																	},
																};
																return temp;
															});
														}
														setNewadmin((pre) => {
															const temp = {
																...pre,
																Company: e.target.value,
															};
															return temp;
														});
													}}
												/>
											</FormGroup>
											{newadminerror.Company.error && (
												<p
													style={{
														color: 'red',
														fontSize: '12px',
													}}>
													{' '}
													{newadminerror.Company.msg
														? newadminerror.Company.msg
														: t('*Required')}
												</p>
											)}
										</div>
										<div className='col-8'>
											<FormGroup id='email' label={t('Email')}>
												<Input
													type='email'
													value={newadmin.Email}
													style={{
														border: newadminerror.Email.error
															? '2px solid red'
															: '2px solid transparent',
													}}
													onChange={(e) => {
														if (newadminerror.Email.error) {
															setNewadminerror((pre) => {
																const temp = {
																	...pre,
																	Email: {
																		error: false,
																		msg: t('*Required'),
																	},
																};
																return temp;
															});
														}
														setNewadmin((pre) => {
															const temp = {
																...pre,
																Email: e.target.value,
															};
															return temp;
														});
													}}
												/>
											</FormGroup>
											{newadminerror.Email.error && (
												<p
													style={{
														color: 'red',
														fontSize: '12px',
													}}>
													{' '}
													{newadminerror.Email.msg
														? newadminerror.Email.msg
														: t('*Required')}
												</p>
											)}
										</div>
										<div className='col-4' style={{ position: 'relative' }}>
											{' '}
											<FormGroup label={t('Password')}>
												<Input
													type={showPasswordnew ? 'text' : 'password'}
													value={newadmin.Password}
													style={{
														border: newadminerror.Password.error
															? '2px solid red'
															: '2px solid transparent',
													}}
													onChange={(e) => {
														if (newadminerror.Password.error) {
															setNewadminerror((pre) => {
																const temp = {
																	...pre,
																	Password: {
																		error: false,
																		msg: t('*Required'),
																	},
																};
																return temp;
															});
														}
														setNewadmin((pre) => {
															const temp = {
																...pre,
																Password: e.target.value,
															};
															return temp;
														});
													}}
												/>

												<button
													type='button'
													onClick={() => togglePasswordVisibilitynew()}
													style={{
														position: 'absolute',
														left: '170px',
														top: '30px',
														// top: '356px',
														// transform: 'translateY(-50%)',
														border: 'none',
														background: 'none',
														cursor: 'pointer',
													}}>
													{showPasswordnew ? (
														<Icon
															style={{
																color:
																	themeStatus === 'dark'
																		? '#c9c3c3'
																		: 'black',
															}}
															icon='Visibility'
															size='2x'
														/>
													) : (
														<Icon
															style={{
																color:
																	themeStatus === 'dark'
																		? '#c9c3c3'
																		: 'black',
															}}
															icon='VisibilityOff'
															size='2x'
														/>
													)}{' '}
												</button>
											</FormGroup>
											{newadminerror.Password.error && (
												<p
													style={{
														color: 'red',
														fontSize: '12px',
													}}>
													{' '}
													{newadminerror.Password.msg
														? newadminerror.Password.msg
														: t('*Required')}
												</p>
											)}
										</div>
										<div className='col-6'>
											<FormGroup id='bday' label={t('Birth Date')}>
												<CustomDatePicker
													styleValue={newadminerror.Birthday.error}
													maxDate={maxSelectableDate}
													value={
														newadmin.Birthday
															? dayjs(newadmin.Birthday, 'YYYY-MM-DD')
															: null
													}
													onChange={(date, dateString) => {
														const formattedDate = date
															? dayjs(date).format('YYYY-MM-DD')
															: '';

														if (newadminerror.Birthday.error) {
															setNewadminerror((pre) => {
																const temp = {
																	...pre,
																	Birthday: {
																		error: false,
																		msg: t('*Required'),
																	},
																};
																return temp;
															});
														}
														setNewadmin((pre) => {
															const temp = {
																...pre,
																Birthday: formattedDate,
															};
															return temp;
														});
													}}
												/>
											</FormGroup>
											{newadminerror.Birthday.error && (
												<p
													style={{
														color: 'red',
														fontSize: '12px',
													}}>
													{' '}
													{newadminerror.Birthday.msg
														? newadminerror.Birthday.msg
														: t('*Required')}
												</p>
											)}
										</div>
										<div className='col-6'>
											<FormGroup label={t('Country')}>
												<Select
													list={uptableOption}
													placeholder={t('Select a Country')}
													value={newadmin.country}
													style={{
														border: newadminerror.country.error
															? '2px solid red'
															: '2px solid transparent',
													}}
													onChange={(e) => {
														if (newadminerror.country.error) {
															setNewadminerror((pre) => {
																const temp = {
																	...pre,
																	country: {
																		error: false,
																		msg: t('*Required'),
																	},
																};
																return temp;
															});
														}
														setNewadmin((pre) => {
															const temp = {
																...pre,
																country: e.target.value,
																Phonec: e.target.value,
															};
															return temp;
														});
													}}
												/>
											</FormGroup>
											{newadminerror.country.error && (
												<p
													style={{
														color: 'red',
														fontSize: '12px',
													}}>
													{' '}
													{newadminerror.country.msg
														? newadminerror.country.msg
														: t('*Required')}
												</p>
											)}
										</div>
										<div className='col-4' style={{ position: 'relative' }}>
											<FormGroup label={t('Phone Code')}>
												<CountryFlagWithPhoneCodeSelector
													onSelect={handleCountrySelect}
													tableOptionc={tableOptionc}
													isError={newadminerror.Phonec.error}
												/>
											</FormGroup>

											{newadminerror.Phonec.error && (
												<p
													style={{
														color: 'red',
														fontSize: '12px',
													}}>
													{' '}
													{newadminerror.Phonec.msg
														? newadminerror.Phonec.msg
														: t('*Required')}
												</p>
											)}
										</div>
										<div className='col-4'>
											<FormGroup id='tp' label={t('Mobile No')}>
												<Input
													type='text'
													// value={newadmin?.customer_phone}
													value={newadmin.tp}
													style={{
														border: newadminerror.tp.error
															? '2px solid red'
															: '2px solid transparent',
													}}
													onChange={(e) => {
														if (newadminerror.tp.error) {
															setNewadminerror((pre) => {
																const temp = {
																	...pre,
																	tp: {
																		error: false,
																		msg: t('*Required'),
																	},
																};
																return temp;
															});
														}
														if (Number(newadmin.Phonec) == 94) {
															if (e.target.value.length < 10) {
																setNewadmin((pre) => {
																	const temp = {
																		...pre,
																		tp: e.target.value,
																	};
																	return temp;
																});
															}
														} else {
															setNewadmin((pre) => {
																const temp = {
																	...pre,
																	tp: e.target.value,
																};
																return temp;
															});
														}
													}}
												/>
											</FormGroup>
											{newadminerror.tp.error && (
												<p
													style={{
														color: 'red',
														fontSize: '12px',
													}}>
													{' '}
													{newadminerror.tp.msg
														? newadminerror.tp.msg
														: t('*Required')}
												</p>
											)}
										</div>
										<div className='col-4'>
											<FormGroup id='gender' label={t('Gender')}>
												<Select
													placeholder={`${t('Choose')}...`}
													value={newadmin.gender}
													list={[
														{ value: 'f', text: t('Female') },
														{ value: 'm', text: t('Male') },
													]}
													style={{
														border: newadminerror.gender.error
															? '2px solid red'
															: '2px solid transparent',
													}}
													onChange={(e) => {
														if (newadminerror.gender.error) {
															setNewadminerror((pre) => {
																const temp = {
																	...pre,
																	gender: {
																		error: false,
																		msg: t('*Required'),
																	},
																};
																return temp;
															});
														}
														setNewadmin((pre) => {
															const temp = {
																...pre,
																gender: e.target.value,
															};
															return temp;
														});
													}}
												/>
											</FormGroup>
											{newadminerror.gender.error && (
												<p
													style={{
														color: 'red',
														fontSize: '12px',
													}}>
													{' '}
													{newadminerror.gender.msg
														? newadminerror.gender.msg
														: t('*Required')}
												</p>
											)}
										</div>
										<div className='col-12'>
											<FormGroup id='address' label={t('Address')}>
												<Input
													style={{
														border: newadminerror.add.error
															? '2px solid red'
															: '2px solid transparent',
													}}
													value={newadmin.add}
													onChange={(e) => {
														if (newadminerror.add.error) {
															setNewadminerror((pre) => {
																const temp = {
																	...pre,
																	add: {
																		error: false,
																		msg: t('*Required'),
																	},
																};
																return temp;
															});
														}
														setNewadmin((pre) => {
															const temp = {
																...pre,
																add: e.target.value,
															};
															return temp;
														});
													}}
												/>
											</FormGroup>
											{newadminerror.add.error && (
												<p
													style={{
														color: 'red',
														fontSize: '12px',
													}}>
													{' '}
													{newadminerror.add.msg
														? newadminerror.add.msg
														: t('*Required')}
												</p>
											)}
										</div>
										<div className='col-6'>
											<FormGroup id='city' label={t('City')}>
												<Input
													type='text'
													value={newadmin.city}
													style={{
														border: newadminerror.city.error
															? '2px solid red'
															: '2px solid transparent',
													}}
													onChange={(e) => {
														if (newadminerror.city.error) {
															setNewadminerror((pre) => {
																const temp = {
																	...pre,
																	city: {
																		error: false,
																		msg: t('*Required'),
																	},
																};
																return temp;
															});
														}
														setNewadmin((pre) => {
															const temp = {
																...pre,
																city: e.target.value,
															};
															return temp;
														});
													}}
												/>
											</FormGroup>
											{newadminerror.city.error && (
												<p
													style={{
														color: 'red',
														fontSize: '12px',
													}}>
													{' '}
													{newadminerror.city.msg
														? newadminerror.city.msg
														: t('*Required')}
												</p>
											)}
										</div>

										<div className='col-6'>
											<FormGroup id='state' label={t('State')}>
												<Input
													type='text'
													value={newadmin.state}
													style={{
														border: newadminerror.state.error
															? '2px solid red'
															: '2px solid transparent',
													}}
													onChange={(e) => {
														if (newadminerror.state.error) {
															setNewadminerror((pre) => {
																const temp = {
																	...pre,
																	state: {
																		error: false,
																		msg: t('*Required'),
																	},
																};
																return temp;
															});
														}
														setNewadmin((pre) => {
															const temp = {
																...pre,
																state: e.target.value,
															};
															return temp;
														});
													}}
												/>
											</FormGroup>
											{newadminerror.state.error && (
												<p
													style={{
														color: 'red',
														fontSize: '12px',
													}}>
													{' '}
													{newadminerror.state.msg
														? newadminerror.state.msg
														: t('*Required')}
												</p>
											)}
										</div>

										<div className='col-6'>
											<FormGroup id='zipcode' label={t('Zip Code')}>
												<Input
													type='text'
													// value={newadmin?.customer_zipcode}
													value={newadmin.zip}
													style={{
														border: newadminerror.zip.error
															? '2px solid red'
															: '2px solid transparent',
													}}
													onChange={(e) => {
														if (newadminerror.zip.error) {
															setNewadminerror((pre) => {
																const temp = {
																	...pre,
																	zip: {
																		error: false,
																		msg: t('*Required'),
																	},
																};
																return temp;
															});
														}
														setNewadmin((pre) => {
															const temp = {
																...pre,
																zip: e.target.value,
															};
															return temp;
														});
													}}
												/>
											</FormGroup>
											{newadminerror.zip.error && (
												<p
													style={{
														color: 'red',
														fontSize: '12px',
													}}>
													{' '}
													{newadminerror.zip.msg
														? newadminerror.zip.msg
														: t('*Required')}
												</p>
											)}
										</div>

										<div className='col-6'>
											<FormGroup id='nic' label={t('NIC')}>
												<Input
													type='text'
													// value={newadmin?.nic}
													value={newadmin.nic}
													style={{
														border: newadminerror.nic.error
															? '2px solid red'
															: '2px solid transparent',
													}}
													onChange={(e) => {
														if (newadminerror.nic.error) {
															setNewadminerror((pre) => {
																const temp = {
																	...pre,
																	nic: {
																		error: false,
																		msg: t('*Required'),
																	},
																};
																return temp;
															});
														}
														setNewadmin((pre) => {
															const temp = {
																...pre,
																nic: e.target.value,
															};
															return temp;
														});
													}}
												/>
											</FormGroup>
											{newadminerror.nic.error && (
												<p
													style={{
														color: 'red',
														fontSize: '12px',
													}}>
													{' '}
													{newadminerror.nic.msg
														? newadminerror.nic.msg
														: t('*Required')}
												</p>
											)}
										</div>
										<Button
											color='info'
											onClick={insertBiz}
											disabled={isLoading}>
											{t('Save')}
										</Button>
									</div>
								</CardBody>
							</Card>
						</div>
					</div>
				</OffCanvasBody>
			</OffCanvas>
		</>
	);
};

export default CommonAdminlist;
